import { theme } from "antd";
import { ExtendedButtonProps, Button as UiButton } from "../../../ui/src";
import { createStyles } from "antd-style";

interface ButtonTokens {
  controlHeight?: number;
  paddingInline?: number;
  fontSize?: number;
  borderRadius?: number;
  primaryGradient?: string;
}

const styleUtils = createStyles(
  (
    { css },
    {
      buttonTokens,
      colorTextLightSolid,
    }: { buttonTokens: ButtonTokens; colorTextLightSolid: string },
  ) => ({
    button: css`
      height: ${buttonTokens.controlHeight ?? 44}px !important;
      padding: 0 ${buttonTokens.paddingInline ?? 64}px !important;
      font-size: ${buttonTokens.fontSize ?? 17}px !important;
      border-radius: ${buttonTokens.borderRadius ?? 4}px !important;

      @media (max-width: 1024px) {
        padding: 0 ${Number.isInteger(buttonTokens.paddingInline) ? Math.round((buttonTokens.paddingInline ?? 64) * 0.5) : 0}px !important;
      }

      @media (max-width: 767px) {
        padding: 0 ${Number.isInteger(buttonTokens.paddingInline) ? Math.round((buttonTokens.paddingInline ?? 64) * 0.3) : 0}px !important;
      }
    `,
    gradient: css`
      background: ${buttonTokens.primaryGradient} !important;
      border: none !important;
      color: ${colorTextLightSolid || "#fff"} !important;

      &:hover {
        opacity: 0.85;
      }
    `,
  }),
);

export const Button = (props: ExtendedButtonProps) => {
  const { token } = theme.useToken();
  const buttonTokens = (token.Button ?? {}) as ButtonTokens;
  const { styles } = styleUtils({
    buttonTokens,
    colorTextLightSolid: token.colorTextLightSolid || "#fff",
  });
  const isGradient = props.type === "primary" && !!buttonTokens.primaryGradient;
  const className = [
    styles.button,
    isGradient && styles.gradient,
    props.className,
  ]
    .filter(Boolean)
    .join(" ");

  return <UiButton {...props} className={className} />;
};
